import { ApiError } from 'src/error/customError/ApiError';
export class InvalidError extends ApiError {}
